import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { addIntersectionObserver, removeIntersectionObserver } from "@cinch-labs/shared-util";
import cx from "classnames";
import { useEffect, useState } from "react";
import styles from "./lazy-image.module.css";
var LazyImage = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, onError = _param.onError, props = _object_without_properties(_param, [
        "className",
        "onError"
    ]);
    var imgRef;
    var ref = useState(false), isLoaded = ref[0], updateLoadedState = ref[1];
    var ref1 = useState(false), isVisible = ref1[0], setVisibility = ref1[1];
    var handleIntersection = function(isIntersecting) {
        if (isIntersecting && !!imgRef) {
            removeIntersectionObserver(imgRef);
            setVisibility(true);
        }
    };
    var addObserver = function() {
        if (imgRef) {
            addIntersectionObserver(handleIntersection, imgRef);
        }
    };
    useEffect(function() {
        if (!imgRef) {
            return;
        }
        addObserver();
        return function() {
            if (imgRef) {
                removeIntersectionObserver(imgRef);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.src
    ]);
    var handleRef = function(ref) {
        if (!ref && imgRef) {
            removeIntersectionObserver(imgRef);
        }
        imgRef = ref;
        addObserver();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var visibleProp = {};
    if (isVisible) {
        visibleProp.src = props.src;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.lazyWrapper,
        children: /*#__PURE__*/ _jsx("img", _object_spread({
            className: cx(styles.lazy, className, _define_property({}, styles.lazyLoaded, isLoaded)),
            ref: handleRef,
            alt: props.alt || "",
            onError: onError,
            onLoad: function() {
                return updateLoadedState(true);
            }
        }, visibleProp))
    });
};
export default LazyImage;
